import { render, staticRenderFns } from "./pl.vue?vue&type=template&id=2ae44216&scoped=true&lang=html&"
import script from "./pl.vue?vue&type=script&lang=js&"
export * from "./pl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae44216",
  null
  
)

export default component.exports